const RANGE_MS = {
    "1h": 60 * 60 * 1000,
    "6h": 6 * 60 * 60 * 1000,
    "24h": 24 * 60 * 60 * 1000,
    "7d": 7 * 24 * 60 * 60 * 1000,
};

// Build query params for getFunctionInvocations from UI filters.
// All filtering now happens on the backend (Athena pushdown);
// the UI owns paging + debounce only.
export function buildFetchParams(filters, { stepId, page = 1, pageSize = 25 } = {}) {
    const rangeMs = RANGE_MS[filters.timeRange] ?? RANGE_MS["1h"];
    const endDate = new Date().toISOString();
    const startDate = new Date(Date.now() - rangeMs).toISOString();

    return {
        stepId,
        light: true,
        page,
        pageSize,
        startDate,
        endDate,
        status: filters.status !== "all" ? filters.status : undefined,
        pathFilter: filters.pathSearch.trim() || undefined,
    };
}
